import LogoutCallback from './LogoutCallback.component';

export default LogoutCallback;
